<template>
  <div class="construction">
    <div class="swiper-container WEBswiper"
         style="width: 100vw;height: 100vh;overflow: hidden;">
      <div class="swiper-wrapper">
        <!-- 第一屏 -->
        <div class="swiper-slide swiper-no-swiping"
             style="width: 100vw;height: 100vh;">
          <Banner></Banner>
        </div>
        <!-- 第二屏 -->
        <div class="swiper-slide swiper-no-swiping"
             style="width: 100vw;height: 100vh;">
          <div style="height: 100%"
               data-scroll="true">

            <el-scrollbar ref="WEBscroll"
                          style="height: 100%">
              <div style="margin-top:0.3646rem">
                <div class="title_box">高端网站建设定制开发服务</div>
                <div class="title_info">专注定制体验流畅、性能响应快、设计主流前卫等优质特性的APP移动端应用软件</div>
                <div class="service_ul">
                  <div class="service_li">
                    <div class="img_box">
                      <div class="img">
                        <img src="../../static/images/img/qiyewangzhan.png"
                             alt="">
                      </div>
                    </div>
                    <div class="text_box">
                      <div class="title">
                        企业网站
                      </div>
                      <div class="text">
                        官方网站是企业对外宣传交流的重要窗口，零一零二信息技术官网建设，为企业量身订造，提供合适企业的官网前沿设计方案。 通过网站目标定位，针对性选择布局，重点展示了客户所关心的内容；并以简洁明朗的设计风格，清晰展现公司水平实力，确保一秒抓住目标用户眼球，给用户留下良好的第一印象。
                      </div>
                    </div>
                  </div>
                  <div class="service_li">
                    <div class="text_box">
                      <div class="title">
                        品牌网站
                      </div>
                      <div class="text">
                        品牌网站以品牌营销为目标，搭配多变创新的设计风格，突出展现企业品牌魅力。河南零一零二信息技术提供的品牌网站建设服务，努力发掘每一品牌的独特记忆点，设定专属的品牌展示角度； 并以震撼的视觉冲击力，塑造令人记忆深刻的品牌形象；助力企业扩大品牌知名度，增强品牌效应。
                      </div>
                    </div>
                    <div class="img_box">
                      <div class="img">
                        <img src="../../static/images/img/pinpaiwangzhan.png"
                             alt="">
                      </div>
                    </div>
                  </div>
                  <div class="service_li">
                    <div class="img_box">
                      <div class="img">
                        <img src="../../static/images/img/waimapwangzhan.png"
                             alt="">
                      </div>
                    </div>
                    <div class="text_box">
                      <div class="title">
                        外贸网站
                      </div>
                      <div class="text">
                        外贸网站是企业在互联网上进行产品展示和形象宣传的平台，面向用户主要为国外客户。按照其功能可以分为浏览型外贸网站和营销型外贸网站， 二者同时具备产品在线销售、企业宣传、内容营销、品牌沉淀等积极作用，不仅只是企业名片，还深度整合SEO优化，智能询盘，智能翻译等功能，助力提升流量，实现企业盈利。
                      </div>
                    </div>
                  </div>
                  <div class="service_li">
                    <div class="text_box">
                      <div class="title">
                        电商网站
                      </div>
                      <div class="text">
                        随着电子商务快速发展，新型电商模式层出不穷。河南零一零二信息技术网站建设，能为企业提供括O2O、B2B、B2C、C2C，分销和B2B2C在内的多种电商平台建设， 帮助企业开辟稳定的商业营销渠道，牢牢占据网络市场。同时，零一零二信息技术还提供个性化营销管理模块，让企业轻松获取订单，高效管理网站。
                      </div>
                    </div>
                    <div class="img_box">
                      <div class="img">
                        <img src="../../static/images/img/dianshangwangzhan.png"
                             alt="">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div class="title_box">我们的特色</div>
                <div class="title_info">为企业量身定制，确保高品质的项目成果交付</div>
                <div class="characteristic_ul">
                  <div class="characteristic_li">
                    <div class="img_box">
                      <div class="img">
                        <img src="../../static/images/img/tese.png"
                             alt="">
                      </div>
                    </div>
                    <div class="text_box">
                      <div class="text">
                        <div class="title">符合用户体验的设计理念和方法论</div>
                        <div class="text_info">零一零二信息技术沉淀了完整的设计理念和方法论，基于专业级的评估需求，提供视觉设计、交互设计、界面设计等整体设计案，确保设计符合互联网用户体验，目前已经在多个项目实践中得到成功验证。</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Footer></Footer>
            </el-scrollbar>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Banner from "@/components/banner.vue";
import Footer from "@/components/footer.vue";
export default {
  components: {
    Banner,
    Footer,
  },
  data () {
    return {
      WEBswiper: "",
      WEBswiperId: 0,
      scrollTop: 0,
    }
  },
  watch: {
    WEBswiperId: {
      handler (e) {
        if (e == 1) {
          this.$refs.WEBscroll.wrap.scrollTop = 1
          this.WEBswiper.disableMousewheelControl()
        }

      }
    }
  },
  mounted () {
    var _this = this
    this.$refs.WEBscroll.wrap.onscroll = (e) => {
      _this.scrollTop = e.target.scrollTop
      if (e.target.scrollTop == 0) {
        _this.WEBswiper.slidePrev()
        _this.WEBswiper.enableMousewheelControl()
      }
    }

    this.WEBswiper = new Swiper('.WEBswiper', {
      direction: 'vertical',
      loop: false, //不循环
      spaceBetween: 0, // swiper-slide 间的距离为0
      autoplay: false, // 不自动切换
      speed: 700, // 每次切换时长
      // scrollbar: '.swiper-scrollbar', // 滚动条
      mousewheelControl: true, // 开启鼠标切换
      noSwiping: true,// 开启不允许切换
      onSlideChangeEnd: function (swiper) {
        _this.WEBswiperId = swiper.activeIndex
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.construction {
  text-align: center;
  .title_box {
    display: inline-block;
    position: relative;
    font-size: 0.2103rem;
    font-family: MicrosoftYaHei;
    color: #000;
    opacity: 1;
    margin: 0.225rem 0 0.1383rem;
  }
  .title_box::before {
    content: "";
    position: absolute;
    left: -0.4083rem;
    top: 58%;
    transform: translateY(-50%);
    width: 0.2083rem;
    height: 0.2188rem;
    background-image: url("../../static/images/icon/title_left.png");
    background-size: 100% 100%;
  }
  .title_box::after {
    content: "";
    position: absolute;
    right: -0.4083rem;
    top: 58%;
    transform: translateY(-50%);
    width: 0.2083rem;
    height: 0.2188rem;
    background-image: url("../../static/images/icon/title_right.png");
    background-size: 100% 100%;
  }
  .title_info {
    font-size: 0.1146rem;
    font-family: MicrosoftYaHei;
    line-height: 0.2083rem;
    color: #999999;
    opacity: 1;
  }
  .banner_box {
    width: 100vw;
    height: 100vh;
  }
  .service_ul {
    margin: 0 1.875rem 0.208rem;
    .service_li {
      display: flex;
      justify-content: space-around;
      border-bottom: 1px dashed #999999;
      padding: 0.3504rem 0 0.4rem;
      .img_box {
        position: relative;
        width: 2.0417rem;
        .img {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 2.0417rem;
          height: 1.3542rem;
        }
      }
      .text_box {
        width: 2.651rem;
        min-height: 1.0417rem;
        text-align: left;
        .title {
          font-size: 0.1354rem;
          font-family: Microsoft YaHei;
          font-weight: bold;
          line-height: 0.25rem;
          color: #000000;
          letter-spacing: 0.0104rem;
          opacity: 1;
        }
        .text {
          font-size: 0.0729rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 0.1458rem;
          color: #000000;
          letter-spacing: 0.0104rem;
          opacity: 1;
        }
      }
    }
    .service_li:last-child {
      border: none;
    }
  }
  .characteristic_ul {
    margin: 0 1.875rem 0.208rem;
    .characteristic_li {
      display: flex;
      justify-content: space-between;
      padding: 0.6504rem 0 0.6rem;
      .img_box {
        position: relative;
        width: 3.6042rem;
        min-height: 1.4375rem;
        .img {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 3.6042rem;
          height: 1.4375rem;
        }
      }
      .text_box {
        text-align: left;
        position: relative;
        width: 2.2813rem;
        .text {
          width: 100%;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          .title {
            width: 100%;
            font-size: 0.1146rem;
            font-family: Microsoft YaHei;
            font-weight: bold;
            line-height: 0.2135rem;
            color: #000000;
            letter-spacing: 0.0104rem;
            opacity: 1;
          }
          .text_info {
            font-size: 0.0729rem;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 0.1458rem;
            color: #000000;
            letter-spacing: 0.0104rem;
            opacity: 1;
            margin-top: 0.1563rem;
          }
        }
      }
    }
  }
  img {
    width: 100%;
    height: 100%;
  }
}
</style>